<div class="body" [ngClass]="getBodyClass()" *ngIf="isWebView">
  <app-header [userProfile]="userProfile" *ngIf="isWebView"></app-header>
  <router-outlet></router-outlet>
</div>
<div [ngClass]="getBodyClass()" *ngIf="!isWebView">
  <app-header [userProfile]="userProfile" *ngIf="isWebView"></app-header>
  <router-outlet></router-outlet>
</div>
